import random from 'toxilibs/random.js'
import nGramsCommons from './commons/ngrams.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'ngrams_cissors_1'
})

const {
    createQuestion,
    cutAndMysteryGram,
    cutAndMysteryLetter
} = nGramsCommons




level.addQuestion({
    generator: function (q) {
        let word = random.unmistakableLetters(random.intBetween(6, 10))

        createQuestion(q, cutAndMysteryGram, {word, n: 1})
    },
    errorExpected: true
})


level.addQuestion({
    generator: function (q) {
        let word = random.unmistakableLetters(random.intBetween(6, 10))

        createQuestion(q, cutAndMysteryLetter, {word, n: 1})
    }
})



export default level

